import { AuthDomainService } from '../../domain/services/AuthDomainService';
import { TokenRepository } from '../../domain/repositories/TokenRepository';
import { User } from '../../domain/entities/User';

/**
 * Application service for token management
 * Coordinates between domain and infrastructure layers
 */
export class TokenService {
  constructor(
    private tokenRepository: TokenRepository,
    private authDomainService: AuthDomainService
  ) {}

  /**
   * Store the token
   */
  setToken(token: string): void {
    this.tokenRepository.setToken(token);
  }

  /**
   * Get the token
   */
  getToken(): string | undefined {
    return this.tokenRepository.getToken();
  }

  /**
   * Remove the token
   */
  removeToken(): void {
    this.tokenRepository.removeToken();
  }

  /**
   * Verify if the token is valid and not expired
   * Delegates to domain service
   */
  verifyToken(token: string): boolean {
    return this.authDomainService.verifyToken(token);
  }

  /**
   * Extract user information from token
   * Delegates to domain service
   */
  extractUserFromToken(token: string): User | null {
    return this.authDomainService.extractUserFromToken(token);
  }
}
